import { jsx as e, jsxs as p } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import { Checkbox as C, VStack as g, Box as a } from "@chakra-ui/react";
import { useCheckboxGroupContext as u } from "./useCheckboxGroup.mjs";
import { Badge as I } from "../../dataDisplay/Badge/Badge.mjs";
import N from "./CustomCheckboxIcon.mjs";
const j = f((s, t) => {
  const { children: o, isDisabled: i, isIndeterminate: d = !1, size: n = "md", value: r, id: m, ...h } = s, { getCheckboxProps: l, variant: c, id: x } = u(), b = l({ value: r }), k = m ?? [x, r].join("-");
  return /* @__PURE__ */ e(
    C,
    {
      ref: t,
      variant: c,
      size: n,
      id: k,
      isDisabled: i,
      isIndeterminate: d,
      icon: /* @__PURE__ */ e(N, {}),
      ...c === "card" && { alignItems: "start" },
      ...b,
      ...h,
      children: c === "card" ? /* @__PURE__ */ p(g, { align: "stretch", spacing: { base: 2, md: 3 }, children: [
        /* @__PURE__ */ e(a, { className: "checkbox-card-badge-container", children: /* @__PURE__ */ e(I, { className: "checkbox-card-selected-badge", status: "recommendation", children: "Selected" }) }),
        /* @__PURE__ */ e(a, { className: "checkbox-card-child-container", children: o })
      ] }) : o
    }
  );
});
j.displayName = "Checkbox";
export {
  j as Checkbox
};
